import { render, staticRenderFns } from "./tm-privacy-policy-page.vue?vue&type=template&id=38b42298&scoped=true&"
import script from "./tm-privacy-policy-page.vue?vue&type=script&lang=ts&"
export * from "./tm-privacy-policy-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b42298",
  null
  
)

export default component.exports